import { useId } from 'react';

const iconStyle: React.CSSProperties = {
  width: '1.25em',
  height: '1.25em',
};

const gradientIconStyle = {
  width: '48px',
  height: '48px',
};

export function EditIcon() {
  const gradientId = useId();
  return (
    <svg style={iconStyle} viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
       <defs>
        <linearGradient id={gradientId} x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="var(--brand-color-1)" />
            <stop offset="100%" stopColor="var(--brand-color-2)" />
        </linearGradient>
      </defs>
      <path fill={`url(#${gradientId})`} d="M17.414 2.586a2 2 0 00-2.828 0L7 10.172V13h2.828l7.586-7.586a2 2 0 000-2.828z" />
      <path fill={`url(#${gradientId})`} fillRule="evenodd" d="M2 6a2 2 0 012-2h4a1 1 0 010 2H4v10h10v-4a1 1 0 112 0v4a2 2 0 01-2 2H4a2 2 0 01-2-2V6z" clipRule="evenodd" />
    </svg>
  );
}

export function PlusIcon() {
    return (
        <svg style={{ width: '1.2em', height: '1.2em' }} viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
            <path fillRule="evenodd" d="M10 3a1 1 0 011 1v5h5a1 1 0 110 2h-5v5a1 1 0 11-2 0v-5H4a1 1 0 110-2h5V4a1 1 0 011-1z" clipRule="evenodd" />
        </svg>
    )
}

export function XIcon() {
    return (
        <svg style={{ width: '1em', height: '1em' }} viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
            <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" />
        </svg>
    )
}

export function DownloadIcon() {
    return (
        <svg style={{ width: '1.2em', height: '1.2em' }} viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
             <path fillRule="evenodd" d="M3 17a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm3.293-7.707a1 1 0 011.414 0L9 10.586V3a1 1 0 112 0v7.586l1.293-1.293a1 1 0 111.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z" clipRule="evenodd" />
        </svg>
    )
}

export function ChevronDownIcon({ isOpen }: { isOpen: boolean }) {
    return (
        <svg style={{ width: '1.2em', height: '1.2em', transition: 'transform 0.2s', transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)'}} viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
            <path fillRule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clipRule="evenodd" />
        </svg>
    )
}

export function ChevronRightIcon() {
    return (
        <svg style={{ width: '1.2em', height: '1.2em' }} viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
            <path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clipRule="evenodd" />
        </svg>
    );
}

export function EyeIcon() {
    return (
        <svg style={iconStyle} viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
            <path d="M10 12a2 2 0 100-4 2 2 0 000 4z" />
            <path fillRule="evenodd" d="M.458 10C1.732 5.943 5.522 3 10 3s8.268 2.943 9.542 7c-1.274 4.057-5.022 7-9.542 7S1.732 14.057.458 10zM14 10a4 4 0 11-8 0 4 4 0 018 0z" clipRule="evenodd" />
        </svg>
    );
}

export function EyeOffIcon() {
    return (
        <svg style={{ width: '1.25em', height: '1.25em' }} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
            <path d="M2 12c2-4 6-7 10-7s8 3 10 7c-2 4-6 7-10 7s-8-3-10-7z" />
            <line x1="3" y1="3" x2="21" y2="21" />
        </svg>
    );
}


const IconWrapper = ({ children }: { children: React.ReactNode }) => {
    const gradientId = useId();
    return (
        <div style={{
            background: 'linear-gradient(135deg, color-mix(in srgb, var(--brand-color-1) 15%, transparent), color-mix(in srgb, var(--brand-color-2) 15%, transparent))',
            borderRadius: 'var(--radius-md)',
            padding: '0.75rem',
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center'
        }}>
            <svg style={gradientIconStyle} viewBox="0 0 24 24" fill="none" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                <defs>
                    <linearGradient id={gradientId} x1="0%" y1="0%" x2="100%" y2="100%">
                        <stop offset="0%" stopColor="var(--brand-color-1)" />
                        <stop offset="100%" stopColor="var(--brand-color-2)" />
                    </linearGradient>
                </defs>
                <g stroke={`url(#${gradientId})`}>
                    {children}
                </g>
            </svg>
        </div>
    );
};

export function BeneficiariosIcon() {
    return (
        <IconWrapper>
            <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
            <circle cx="9" cy="7" r="4"/>
            <path d="M23 21v-2a4 4 0 0 0-3-3.87"/>
            <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
        </IconWrapper>
    );
}

export function PrestadoresIcon() {
  return (
        <IconWrapper>
            <path d="M14 22.5H22.5V13L18.7 9.1V8.2a6.7 6.7 0 0 0-13.4 0v1L1.5 13V22.5h8.6V18.7h3.8v3.8z"/>
            <line x1="9.1" y1="7.2" x2="14.9" y2="7.2" stroke="#4795eeff"/>
            <line x1="12" y1="4.4" x2="12" y2="10.1" stroke="#4795eeff"/>
        </IconWrapper>
  );
}


export function PlanosIcon() {
    return (
        <IconWrapper>
            <rect x="3" y="5" width="18" height="14" rx="2" ry="2"/>
            <circle cx="8.5" cy="10.5" r="1.5"/>
            <path d="M8.5 14.5a3 3 0 0 0-3 3h6a3 3 0 0 0-3-3z"/>
            <line x1="14" y1="10" x2="18" y2="10" stroke="#4795eeff"/>
            <line x1="14" y1="14" x2="18" y2="14" stroke="#4795eeff"/>
        </IconWrapper>
    );
}

export function ServicosIcon() {
    return (
        <IconWrapper>
            <path d="M5 4H4a1 1 0 0 0-1 1v4c0 2.8 2.2 5 5 5h0c2.8 0 5-2.2 5-5V5a1 1 0 0 0-1-1h-1"/>
            <path d="M8 14v1.5c0 3 2.5 5.5 5.5 5.5h0c3 0 5.5-2.5 5.5-5.5V14"/>
            <line x1="10" y1="3" x2="10" y2="5" stroke="#4795eeff"/>
            <line x1="6" y1="3" x2="6" y2="5" stroke="#4795eeff"/>
        </IconWrapper>
    );
}

export function LocalizacaoIcon() {
    return (
        <IconWrapper>
            <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/>
            <circle cx="12" cy="10" r="3"/>
        </IconWrapper>
    );
}

export function SegurancaIcon() {
    return (
        <IconWrapper>
            <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
            <path d="M12 19s5-2.5 5-6.5V8.5l-5-2-5 2v4c0 4 5 6.5 5 6.5z" transform="translate(0, -1)"/>
            <path d="M9.5 12.5l1.5 1.5 3.5-3.5" fill="none" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" transform="translate(0, -1)"/>
        </IconWrapper>
    );
}


const themeIconStyle: React.CSSProperties = {
    width: '24px',
    height: '24px',
};

export function SunIcon() {
  const gradientId = useId();
  return (
    <svg style={themeIconStyle} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <defs>
            <linearGradient id={gradientId} x1="0%" y1="0%" x2="100%" y2="100%">
                <stop offset="0%" stopColor="var(--brand-color-1)" />
                <stop offset="100%" stopColor="var(--brand-color-2)" />
            </linearGradient>
        </defs>
      <path d="M12 3V4M12 20V21M4 12H3M6.31412 6.31412L5.5 5.5M17.6859 6.31412L18.5 5.5M6.31412 17.69L5.5 18.5001M17.6859 17.69L18.5 18.5001M21 12H20M16 12C16 14.2091 14.2091 16 12 16C9.79086 16 8 14.2091 8 12C8 9.79086 9.79086 8 12 8C14.2091 8 16 9.79086 16 12Z" stroke={`url(#${gradientId})`} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"></path>
    </svg>
  );
}

export function MoonIcon() {
  const gradientId = useId();
  return (
    <svg style={themeIconStyle} viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <linearGradient id={gradientId} x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="var(--brand-color-1)" />
            <stop offset="100%" stopColor="var(--brand-color-2)" />
        </linearGradient>
      </defs>
      <path d="M12.516,4.509A12,12,0,0,0,22.3,19.881,12.317,12.317,0,0,0,24,20a11.984,11.984,0,0,0,3.49-.514,12.1,12.1,0,0,1-9.963,8.421A12.679,12.679,0,0,1,16,28,12,12,0,0,1,12.516,4.509M16,0a16.5,16.5,0,0,0-2.212.15A16,16,0,0,0,16,32a16.526,16.526,0,0,0,2.01-.123A16.04,16.04,0,0,0,31.85,18.212,16.516,16.516,0,0,0,32,15.944,1.957,1.957,0,0,0,30,14a2.046,2.046,0,0,0-1.23.413A7.942,7.942,0,0,1,24,16a8.35,8.35,0,0,1-1.15-.08,7.995,7.995,0,0,1-5.264-12.7A2.064,2.064,0,0,0,16.056,0Z" fill={`url(#${gradientId})`} />
    </svg>
  );
}